import React from "react";

import classes from "./MainNavigation.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "../UI/Button/Button";

import logo from "../../images/Untitled_design-removebg-preview.png";
const MainNavigation = () => {
  // const [isNavExpanded, setIsNavExpanded] = useState(false);
  // const toogleNav = () => {
  //   setIsNavExpanded(!isNavExpanded);
  // };
  // const closeMenu = () => {
  //   setIsNavExpanded(false);
  // };

  const navigate = useNavigate();
  const addQuoteHandler = (quoteData) => {
    console.log(quoteData);
    navigate("/contacts");
  };
  return (
    <header className={classes.header}>
      <NavLink to="/home" className={classes.logo}>
        <img src={logo} alt="logo" />
      </NavLink>
      <nav className={classes.nav}>
        <ul>
          <li>
            <NavLink
              to="/home"
              style={({ isActive }) =>
                isActive
                  ? {
                      color: "red",
                    }
                  : {}
              }
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              style={({ isActive }) =>
                isActive
                  ? {
                      color: "red",
                    }
                  : {}
              }
            >
              About
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/skills"
              style={({ isActive }) =>
                isActive
                  ? {
                      color: "red",
                    }
                  : {}
              }
            >
              Skills/Education
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/projects"
              style={({ isActive }) =>
                isActive
                  ? {
                      color: "red",
                    }
                  : {}
              }
            >
              Portfolio
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contacts"
              style={({ isActive }) =>
                isActive
                  ? {
                      color: "red",
                    }
                  : {}
              }
            >
              Connect
            </NavLink>
          </li>
        </ul>
      </nav>
      <Button onClick={addQuoteHandler} className={classes.connect}></Button>
    </header>
  );
};

export default MainNavigation;
